import {WistiaSvc} from '../../services/WistiaSvc';

class DifferentDevices implements ng.IComponentController {
    videos: anm.LandingVideo[];
    private wistiaInstances: any[] = [];

    constructor(private wistiaSvc: WistiaSvc) {
        let i = 0;
        _.each(this.videos, video => {
            this.wistiaSvc.getWistiaPlayer(video.wistiaId).then((video: any) => {
                this.wistiaInstances.push(video);

                video.bind('play', () => {
                    video.time(0);
                    video.pause();

                    if (++i === 3) {
                        this.playTogether();
                    }

                    return video.unbind;
                })
            });
        });
    }

    private playTogether() {
        setTimeout(() => {
            this.wistiaInstances.forEach(video => video.play());
        }, 0);
    }
}

angular.module('animatronApp.differentDevices', []).component('differentDevices', {
    bindings: {
        videos: '<'
    },
    controller: DifferentDevices,
    templateUrl: require('landing-template/components/different-devices.html')

});



// WEBPACK FOOTER //
// ./app/assets/javascripts/landing-template/components/DifferentDevices.ts